import { render, staticRenderFns } from "./ReadFileFromLocal.vue?vue&type=template&id=4ce4c88e&scoped=true"
import script from "./ReadFileFromLocal.vue?vue&type=script&lang=js"
export * from "./ReadFileFromLocal.vue?vue&type=script&lang=js"
import style0 from "./ReadFileFromLocal.vue?vue&type=style&index=0&id=4ce4c88e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce4c88e",
  null
  
)

export default component.exports